import { Input } from 'antd';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { activeUserInfo } from '../../services/UsersService';
import Axios from '../../config/axios';

const { Search } = Input;

const ClientSearch = ({ setAvailableClients }) => {
    const [value, setValue] = useState([]);
    const [loading, setLoading] = useState(false);
    const uInfo = useRecoilValue(activeUserInfo);

    var apipath = `/api/GetClients?org_ID=${uInfo.organizations_ID}&users_ID=${uInfo.users_ID}&from=campaign&sortBy=firstName&sortDirection=asc&placementStatus=Active&searchValue=${''}`

    function handleSearch(value, e) {
        setLoading(true);
        Axios.get(apipath + value).then(res => {
            setLoading(false);
            setAvailableClients(res?.data?.userClients);
        });
    }

    return (
        <>
            <Search className="py-4" placeholder="Search for Keywords..." loading={loading} enterButton onSearch={handleSearch} onChange={(e) => setValue(e.target.value)} value={value} />
            <button className="btn ant-btn-primary btn-sm mb-3" onClick={() => handleSearch(value)}>Search</button>
        </>
    );
};
export default ClientSearch;